document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll("[data-js-product-add-to-cart]");
  const atc = document.getElementById("add-to-cart-button");
  const atcSticky = document.getElementById("add-to-cart-button-sticky");
  const barraSticky = document.querySelector(".sticky-navbar-buy-buttons");

  const original = window.single_vison || {};

  window.single_vison = new Proxy(original, {
    set(target, prop, value) {
      target[prop] = value;
      if (prop === "ready_to_add_to_cart") {
        buttons.forEach((btn) => {
          if (value) {
            btn.removeAttribute("disabled");
          } else {
            btn.setAttribute("disabled", "true");
          }
        });
      }
      return true;
    },
  });

  if (!atc || !barraSticky) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        barraSticky.classList.add("hidden");
      } else {
        barraSticky.classList.remove("hidden");
      }
    },
    {
      root: null,
      threshold: 0.1,
    }
  );

  observer.observe(atc);

  if (atc && atcSticky) {
    atcSticky.addEventListener("click", (e) => {
      e.preventDefault();
      atc.click();
    });
  }
});
